// TODO: investigate why we get this error here, only in the CI step in Github actions: Cannot find module '@nuxtjs/device/runtime/types/index' or its corresponding type declarations.
// import type { Device } from '@nuxtjs/device/runtime/types/index'
import type {
  SbImage,
  SanitizedImage,
} from '~/cms/storyblok/types/storyblok.d.ts'

type Device = {
  userAgent: string
  isDesktop: boolean
  isIos: boolean
  isAndroid: boolean
  isMobile: boolean
  isMobileOrTablet: boolean
  isDesktopOrTablet: boolean
  isTablet: boolean
  isWindows: boolean
  isMacOS: boolean
  isApple: boolean
  isSafari: boolean
  isFirefox: boolean
  isEdge: boolean
  isChrome: boolean
  isSamsung: boolean
  isCrawler: boolean
}


export function getCmsImage(cmsImg: SbImage, $device?: Device): SanitizedImage {
  const device = $device || useNuxtApp().$device
  const sanitizedImage: SanitizedImage = reactive({
    src: '',
    alt: '',
  })

  if (cmsImg) {
    sanitizedImage.src =
      cmsImg[device.isMobile ? 'mobile_image' : 'desktop_image']?.filename || ''
    sanitizedImage.alt =
      cmsImg[device.isMobile ? 'mobile_image' : 'desktop_image']?.alt || ''
  }
  return sanitizedImage
}

export function getTeaserImage(blok: any) {
  const { $device } = useNuxtApp() as any
  const sanitizedImage: SanitizedImage = reactive({
    src: '',
    alt: '',
  })
  const desktopImageProperty = 'teaser_image'
  const mobileImageProperty = 'teaser_image_mobile'

  if (blok) {
    const image =
      blok[$device.isMobile ? mobileImageProperty : desktopImageProperty]
    sanitizedImage.src = image?.filename || ''
    sanitizedImage.alt = image?.alt || image?.name || ''
  }
  return sanitizedImage
}
